export default "__VITE_ASSET__DhA$N2OE__"